



















import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { DataTableState, TableContext } from '@/typings/datatable';
import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';
import Toast from '@/components/display/toast.vue';
import routerLinkButton from '@/components/elements/buttons/router-link-button.vue';
import { ApiUtils, FilterParam } from '@/common/ApiUtils';
import { SimCardService } from '@/services/sim-card-service';
import { SimCard } from '@/api';

@Component({
	components: {
		secondaryNav,
		DataTableWithFilters,
		routerLinkButton,
	},
})
export default class SimCardList extends Vue {
	private toast: Toast = new Toast();
	private simCardService: SimCardService = new SimCardService();

	public state: DataTableState = {
		fields: [
			{ key: 'id', sortable: true },
			{ key: 'iccid', sortable: true },
			{ key: 'apn', sortable: true },
			{ key: 'imsi', sortable: true },
			{ key: 'transceiver_id', sortable: true },
		],
		loading: false,
		search: null,
		sortBy: 'id',
		primaryKey: 'id',
		sortDesc: false,
		perPage: 20,
		currentPage: 1,
		totalRows: 0,
	};

	public filters: DataTableFilter[] = [
		{
			label: 'APN',
			field: 'apn',
			value: [],
			type: 'checkboxes',
			options: [
				{ text: 'Vodafone', value: 'spe.inetd.gdsp' },
				{ text: 'Onomondo', value: 'onomondo' },
				{ text: 'Hologram', value: 'hologram' },
			],
		},
	];

	public clickTable(sim: SimCard, newTab: boolean) {
		const routeData = {
			name: 'simCards.view',
			params: { simId: sim.id },
		};
		newTab ? window.open(this.$router.resolve(routeData).href) : this.$router.push(routeData);
	}

	public async dataTableProvider(ctx: TableContext): SimCard[] {
		const filters: FilterParam[] = this.filters.map((filter: DataTableFilter) => {
			return { field: filter.field, value: filter.value };
		});

		if (this.state.search !== null) {
			this.state.search = this.state.search.replaceAll(' ', '-');
			filters.push({ field: 'custom', value: this.state.search });
		}

		const response = await this.simCardService.getSimCards(ApiUtils.queryOptions(filters, ctx));
		if (response.simCards) {
			const data: SimCard[] = response.simCards.data ?? [];
			this.state.totalRows = response.simCards.meta.total ?? 0;
			return data;
		} else if (response.errorMessage) {
			this.toast.makeToast(response.errorMessage, 'SIM Card Error', 'danger');
			return [];
		}
	}
}
